import React from 'react';
import { remediationApi } from '../services/api';
import { RegisterItemDetail } from './RegisterItemDetail';

export const RemediationDetail: React.FC = () => {
  return (
    <RegisterItemDetail
      kind="remediation"
      idParam="id"
      title="Remediation"
      iconClass="ri-tools-line"
      api={remediationApi}
    />
  );
};
